import { BaseTag }   from "mixs/base/base_mixin";
import { Global, HistoriesBase }    from "mixs/histories/base";
import moment from 'moment';
import { AddressHashUtil } from 'utilities/address';
import { GOTO_THE_HISTORY } from 'apps/events'
import RiotEventManager   from 'utilities/riot/event_manager';
import jump from 'jump.js';
export class Histories extends HistoriesBase {
  histories = [];
  currentMoment: any;
  currentUser: number;
  eventManager: RiotEventManager;
  init(){
    super.init();
    this.eventManager = new RiotEventManager(this)
    this.eventManager.customEvent(GOTO_THE_HISTORY, (e) => {this.goto_the_history(e)})
    this.updateHistories(this.opts);
    this.listenMount([this.onMountHistories]);
    this.watch();
  }
  onMountHistories() {
    let hash = AddressHashUtil.parse()
    if(!('history' in hash)){ return; }
    this.dispatchGotoHistory(hash);
  }
  dispatchGotoHistory(hash){
    let customEvent = new CustomEvent(GOTO_THE_HISTORY, {});
    document.dispatchEvent(customEvent);
  }
  updateHistories(opts){
    this.currentMoment = null;
    this.currentUser   = null;
    this.histories = [];
    let index = -1;
    let ids = opts.history_ids
    if(!Array.isArray(ids)){ ids = []}
    for(let i=0; i<ids.length; i++){
      let id = ids[i];
      let isSameDate = this.updateCurrentDate(id)
      let isSameUser = this.updateCurrentUser(id)
      if(!isSameDate || !isSameUser){
        index = index + 1;
        this.histories[index] = {date: '', user: '', logs: []}
        if(!isSameDate){
          this.histories[index]['date'] = this.loggedDateAgo(id);
        }
        if(!isSameUser){
          this.histories[index]['user'] = this.userName(id);
        }
      }
      this.histories[index]['logs'].push(id);
    }
  }
  onChangeStore(a, b, c){
    this.opts.histories = []
    this.update();
    this.updateHistories(a);
    super.onChangeStore(a, b, c);
  }
  updateCurrentDate(id){
    let loggedMoment = this.loggedMoment(id);
    let isSame = false;
    if(this.currentMoment){
      let dayAgo = moment().diff(this.currentMoment, 'days');
      if(dayAgo >= 1){
        let format = 'YYYYMMDD'
        isSame = this.currentMoment.format(format) == loggedMoment.format(format)
      }else{
        let diff = this.currentMoment.diff(loggedMoment, 'minutes');
        isSame = diff < 5 // 当日は前の変更より5分以南であれば同じ日時として表示する
      }
    }
    this.currentMoment = loggedMoment
    return isSame;
  }
  updateCurrentUser(id){
    let userId = this.userId(id)
    let isSame = this.currentUser == userId;
    if(!isSame){
      this.currentUser = userId;
    }
    return isSame;
  }
  userName(id){
    if(id == undefined){ id = this.opts.user_id }
    let userId = this.userId(id);
    return super.userName(userId);
  }
  userId(id){
    if(id == undefined){ id = this.opts.user_id }
    let data = Global.getHistoryData(id);
    if(data == undefined) { return 0 }
    return data.user_id
  }
  loggedDate(id){
    if(id == undefined){ id = this.opts.id }
    let data = Global.getHistoryData(id)
    if(data == undefined) { return '' }
    return data.created_at
  }
  loggedMoment(id){
    let loggedDate = this.loggedDate(id);
    return moment(loggedDate);
  }
  loggedDateAgo(id){
    return this.loggedMoment(id).fromNow();
  }
  goto_the_history(e){
    setTimeout(() => {
      jump(this.rootElement(),{
        duration: 500,
        offset: -80
      })
    }, 500)
  }
}
riot.mixin('histories.histories', Histories as riot.TagMixin)
